import { render, staticRenderFns } from "./systemMessages.vue?vue&type=template&id=48268fca&scoped=true&"
import script from "./systemMessages.vue?vue&type=script&lang=js&"
export * from "./systemMessages.vue?vue&type=script&lang=js&"
import style0 from "./systemMessages.vue?vue&type=style&index=0&id=48268fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48268fca",
  null
  
)

export default component.exports